import type { Thread, ThreadPriority } from '@central/api';
import { StatusChip } from '@central/ui';
import { priorityChip } from '../lib/inbox';

/** A thread's priority chip. */
export function PriorityChip({ p }: { p: ThreadPriority }) {
  const chip = priorityChip[p];
  return (
    <span aria-label={`Priority: ${chip.label}`} style={{ display: 'inline-flex' }}>
      <StatusChip tone={chip.tone}>{chip.label}</StatusChip>
    </span>
  );
}

/**
 * Tier 1 (with the reseller) and escalated threads say so; a direct
 * customer's thread, always Rethink's, shows nothing.
 */
export function TierChip({ t }: { t: Thread }) {
  if (t.tier === 'tier1') return <StatusChip tone="blu">Tier 1 · reseller</StatusChip>;
  if (t.escalatedAt) return <StatusChip tone="vio">Escalated</StatusChip>;
  return null;
}
